// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3gTyC","base":"styles_base__1Luq7","isCollapsed":"styles_isCollapsed__hqhoz"};